import Image from 'app/Components/Shared/Image/image';
import React, {useMemo} from 'react';
import {useSelector} from 'react-redux';
import CheckIcon from './Images/check.svg';
import './MoreInfo.scss';
import {FuntoneSubscriptionStatus} from './../../FuntoneSlice';

const MoreInfo = ({selectedPackage, isChangePackageFlow, contentData}) => {
  const {selectedSubscriber, subscribersData, primaryContact } = useSelector((state) => state.FuntoneSlice);

  const renderText = (item) => {
    if (item == null) return '';
    if (typeof item === 'string' || typeof item === 'number') return item;
    if (typeof item === 'object') return item.value ?? '';
    return String(item);
  };

  const hasPremiumPrice = selectedSubscriber.hasPremiumPackage;
  const songPrice = contentData?.standardSongPrice?.value || '5.90';
  
  return (
    <div className='more-info'>
      {selectedSubscriber.hasService && !isChangePackageFlow && (
        !hasPremiumPrice ? (
          <div className='info-description'>
            <Image className='check-icon' src={CheckIcon} alt='' />
              <span className='description-text'>
                תחוייב בתשלום חד פעמי בסך ₪{songPrice} דרך מנוי {selectedSubscriber.cli}
            </span>
          </div>
        ) : (
          <>
            <div className='info-description'>
              <Image className='check-icon' src={CheckIcon} alt='' />
              <span className='description-text'>הורדת שיר הינה ללא תשלום</span>
            </div>
            <div className='info-description'>
              <Image className='check-icon' src={CheckIcon} alt='' />
              <span className='description-text'>ניתן להחליף שיר מתי שרוצים דרך עמוד הניהול באזור האישי</span>
            </div>
          </>
        )
      )}

      {!selectedSubscriber.hasService && !isChangePackageFlow && selectedPackage?.moreInfo?.value?.map((info, index) => (
        <React.Fragment key={index}>
          <div className='info-description'>
            <Image className='check-icon' src={CheckIcon} alt='' />
            <span className='description-text'>{renderText(info)}</span>
          </div>
          {index === 1 && !selectedSubscriber.hasService && !isChangePackageFlow && (
            <div className='info-description'>
              <Image className='check-icon' src={CheckIcon} alt='' />
              <span className='description-text'>
                הסכום יחוייב דרך המנוי {selectedSubscriber.cli}
              </span>
            </div>
          )}
        </React.Fragment>
      ))}
      {(!selectedPackage?.moreInfo?.value || selectedPackage.moreInfo.value.length < 2) && !selectedSubscriber.hasService && !isChangePackageFlow && (
        <div className='info-description'>
          <Image className='check-icon' src={CheckIcon} alt='' />
          <span className='description-text'>
            הסכום יחוייב דרך המנוי {selectedSubscriber.cli}
          </span>
        </div>
      )}
    </div>
  );
};

export default MoreInfo;
